<template>
  <BaseButton
    ref="button"
    @click="onClick"/>
</template>

<script>
/**
 * @deprecated Use {@link BaseButton} directly with tracking-name prop.
 */
export default {}
</script>
<script setup>
import { ref } from 'vue'
import BaseButton from '@shared/components/ADORN/BaseButton.vue'
import { useClickTracker, useTrackingLinkClick } from '@shared/composables/link.js'

const props = defineProps({
  targetName: {
    type: String,
    default: null,
    validator: (value, props) => !value || (!props.appEntryPoint && !props.eventLabel && props.data)
  },
  data: {
    type: Object,
    default: () => ({}),
    validator: (value, props) => Object.keys(value).length === 0 || (!props.appEntryPoint && !props.eventLabel && props.targetName)
  },

  // Props below are deprecated.
  appEntryPoint: {
    type: String,
    default: null,
    validator: (value, props) => !value || (['homepage', 'website', 'signup'].includes(value) && props.eventLabel)
  },
  eventLabel: {
    type: String,
    default: null,
    validator: (value, props) => !value || props.appEntryPoint
  }
})

const emit = defineEmits({
  click: (event) => event instanceof MouseEvent
})

const button = ref(null)
const onClick = props.targetName
  ? useClickTracker(
      () => props.targetName,
      'button',
      () => props.data,
      emit,
      () => button.value.link
    )
  : useTrackingLinkClick(
      () => props.appEntryPoint,
      () => props.eventLabel,
      emit,
      () => button.value.link
    )
</script>
